import React, { useLayoutEffect, useRef } from 'react';
import { sanitizeRecordFragment } from '@helpers/helpers_index/sanitizeHtml';

type Props = {
  __html: string;
  // The element it shows in: a <p> by default (the timeline), a <div> in a block of its own (a Memed posology)
  as?: 'p' | 'div' | 'span';
};

// Shows a record's HTML (its <br>, <b>, lists…). The HTML comes from other users, so only its formatting is shown:
// sanitizeRecordFragment makes it again in the page with no scripts, event handlers or attributes, and those nodes
// are appended as they are (no innerHTML: nothing parses them again).
const HMLDOMInjector = ({ __html, as: Tag = 'p' }: Props) => {
  const ref = useRef(null);

  // Before the browser paints, so the placeholder never shows for a frame, and before a parent's layout effect (or
  // componentDidUpdate) could measure the element without its text
  useLayoutEffect(() => {
    const el = ref.current;
    if (el) {
      // replaceChildren(…), which older Android WebViews (before Chrome 86) don't have
      el.textContent = '';
      el.appendChild(sanitizeRecordFragment(__html));
    }
  }, [__html, Tag]);


  return (
    <Tag ref={ref} className="HMLDOMInjector">&nbsp;</Tag>
  );
};



export default React.memo(HMLDOMInjector);
